import moment from 'moment'
// 显示报名截止时间
export const showOverTime = (applyEndTime) => {
  const currentTime = new Date().getTime()
  const remainingTime = new Date(applyEndTime).getTime() - currentTime
  const leftTime = remainingTime < 0 ? 0 : remainingTime
  let cutOffHint = `<span class="tip">报名已截止</span>`
  let cutOffStatus = leftTime
  if (leftTime) {
    const days = parseInt(`${leftTime / 1000 / 60 / 60 / 24}`, 10)
    const hours = parseInt(`${(leftTime / 1000 / 60 / 60) % 24}`, 10)
    const minutes = parseInt(`${(leftTime / 1000 / 60) % 60}`, 10)
    const seconds = parseInt(`${(leftTime / 1000) % 60}`, 10)
    let showDays = 0
    let showHours = 0
    if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
      cutOffHint = `<span class="tip">报名已截止</span>`
      cutOffStatus = 0
    } else if (days == 0 && hours == 0 && (minutes != 0 || seconds != 0)) {
      cutOffHint = '报名剩余不足 <span class="time">01</span> 小时'
    } else if (days >= 90) {
      cutOffHint = `<span class="tip">长期有效</span>`
    } else {
      showDays = days < 10 ? `0${days}` : days + ''
      showHours = hours < 10 ? `0${hours}` : hours + ''
      cutOffHint = `<span class="time">${showDays}</span> 天 <span class="time">${showHours}</span> 时`
    }
  }
  return {
    cutOffHint,
    cutOffStatus,
  }
}

export function copy(value) {
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', value)
  input.select()
  const copyLine = document.execCommand('copy')
  document.body.removeChild(input)
  return copyLine
}

export function showTime(time) {
  let start = moment() //获取开始时间
  let end = moment(time) //结束时间
  let diff = end.diff(start) //时间差
  let timediff = Math.round(diff / 1000)
  //获取还剩多少天
  let day = parseInt(timediff / 3600 / 24)
  //获取还剩多少小时
  let hour = parseInt((timediff / 3600) % 24)
  //获取还剩多少分钟
  let minute = parseInt((timediff / 60) % 60)
  //获取还剩多少秒
  let second = timediff % 60
  //给小于10的数值前面加 0
  function timerFilter(params) {
    if (params - 0 < 10) {
      return '0' + params
    } else {
      return params
    }
  }
  return {
    day: timerFilter(day),
    hour: timerFilter(hour),
    minute: timerFilter(minute),
    second: timerFilter(second),
  }
}
